const { __, _x, _n, _nx } = wp.i18n;

const UserFilterSelect = ( props ) => {
	return (
		<select value={props.userFilter} onChange={event => props.setUserFilter( event.target.value )}>
			<option key="all" value="all">
				{__( "All users", "iportal-core" )}
			</option>
			<option key="with_role" value="with_role">
				{__( "Users having at least one role on any page", "iportal-core" )}
			</option>
			<option key="without_role" value="without_role">
				{__( "Users having no role on all pages", "iportal-core" )}
			</option>
		</select>
	);
};

export default UserFilterSelect;